import { post } from 'axios';
import cookie from 'react-cookies';
import API from '../../settings/api';
import { redirectIfTariffRequired } from './tariff';

function failureText( err, fallback ) {

  if ( typeof err === 'string' && err ) { return err; }
  if ( err?.message ) { return err.message; }

  return fallback;

}

export async function load( store ) {

  const token = cookie.load( 'token' );

  try {

    const { status, data } = await post( API.companies.pricelist.own, {}, { headers: { token } } );

    if ( redirectIfTariffRequired( data ) ) return { success: false, tariffRequired: true };

    if ( status !== 200 || !data?.success || !Array.isArray( data?.pricelist ) ) {

      throw ( data?.text || 'Не удалось загрузить прайс' );

    }

    store.setState({ company_pricelist: data.pricelist });

    return { success: true };

  } catch ( err ) {

    console.error( err );

    return {

      success: false,
      text: failureText( err, 'Не удалось загрузить прайс' ),

    };

  }

}

export async function save( store, payload = {} ) {

  const token = cookie.load( 'token' );

  const body = {

    pricelist_type: payload.pricelist_type,
    target_id: payload.target_id,
    price: payload.price,
    pricePerJob: payload.pricePerJob,
    isMultiPrice: payload.isMultiPrice === true,

  };

  if ( body.isMultiPrice ) {

    body.multiPriceIndex = payload.multiPriceIndex;

  }

  try {

    const { status, data } = await post( API.companies.pricelist.ownEdit, body, { headers: { token } } );

    if ( redirectIfTariffRequired( data ) ) return { success: false, tariffRequired: true };

    if ( status !== 200 || !data?.success ) {

      throw ( data?.text || 'Не удалось сохранить цену' );

    }

    const refreshed = await load( store );
    await store.actions.global.get();

    if ( !refreshed.success ) {

      return {

        success: true,
        text: 'Цена сохранена, но прайс не удалось обновить',

      };

    }

    return { success: true };

  } catch ( err ) {

    console.error( err );

    return {

      success: false,
      text: failureText( err, 'Не удалось сохранить цену' ),

    };

  }

}
